const TripToolTipStyles = (theme) => {
  return {
    tripTooltipPopper: {
      zIndex: 990
    },
    tripTooltip: {
      width: 330,
        minWidth: 330,
          maxWidth: 330,
    },
    flightTooltip: {
      width: 100,
      minWidth: 100,
      maxWidth: 100,
    },
    rotate90: {
      transform: [{ rotate: '90deg' }]
    },
    timeBlock: {
      textAlign: "center"
    },
    header: {
      fontSize: 12,
      fontWeight: 1000,
      paddingBottom: 5
    },
    date: {
      fontSize: 10,
      fontWeight: 1000
    },
    time: {
      fontSize: 12,
      fontWeight: 1000
    },
    scrollArea: {
      width: "100%",
      height: "calc(100% - 246px)",
      maxHeight: "calc(100% - 246px)",
      minHeight: 420,
      '&::-webkit-scrollbar': {
        width: 4,
        backgroundColor: "rgba(112, 112, 112, 1)",
        color: "rgba(112, 112, 112, 1)"
      },
      '&::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.1)',
        outline: '1px solid slategrey'
      },
      overflowY: "scroll",
      overflowX: "clip"
    },
    crewTable: {
      backgroundColor: "rgba(112, 112, 112, 1)",
    },
    crewTableHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
    },
    crewTableHeaderCell: {
      padding: "6px 16px",
      color: "rgba(255,255,255,1)",
      fontWeight: "bold"
    },
    crewTableLine: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      color: "#202020",
    },
    crewTableDeadHeadLine: {
      backgroundColor: "rgba(215, 215, 215, 1)",
      color: "#202020",
    },
    crewTableCell: {
      padding: "6px 16px",
      color: "#202020",
    },

    paxTable: {
      backgroundColor: "rgba(112, 112, 112, 1)",
    },
    paxTableHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
    },
    paxTableHeaderCell: {
      padding: "6px 16px",
      color: "rgba(255,255,255,1)",
      fontWeight: "bold"
    },
    paxTableLine: {
      backgroundColor: "rgba(255, 255, 255, 1)",
    },
    paxTableCell: {
      padding: "6px 16px",
      color: "#202020",
    },

    permitTable: {
      width: "calc(100% - 6px)",
      marginLeft: 4
    },

    permitTypeHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
      fontWeight: "bold",
      marginTop: 8,
      padding: 3
    },

    permitRow: {
      fontSize: 12,
      paddingTop: 6,
      paddingBottom: 4,
      borderBottom: "1px solid #d0d0d0",
    },

    fuelHeaderRow: {
      fontSize: 16,
      backgroundColor: "rgba(0,0,0,0.3)",
      fontWeight: "bold",
      paddingTop: 8,
      paddingBottom: 6,
    },

    fuelRow: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      color: "#202020",
      fontSize: 16,
      paddingTop: 8,
      paddingBottom: 6,
      borderBottom: "1px solid #d0d0d0",
    },

    serviceDirectionHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
      fontWeight: "bold",
      marginTop: 8,
      padding: 3
    },

    serviceRow: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      color: "#202020",
      fontSize: 14,
      paddingTop: 8,
      paddingBottom: 6,
      borderBottom: "1px solid #d0d0d0",
    },

    slotDirectionHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
      fontWeight: "bold",
      marginTop: 8,
      padding: 3
    },

    slotRow: {
      lineHeight: "20px",
      backgroundColor: "rgba(255, 255, 255, 1)",
      color: "#202020",
      fontSize: 14,
      paddingTop: 6,
      paddingBottom: 6,
      borderBottom: "1px solid #d0d0d0",
    },

    cateringStatusRow: {
      marginTop: 4,
      padding: 3,
      fontSize: 14,
    },
    cateringHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
      fontWeight: "bold",
      marginTop: 8,
      padding: 3
    },
    cateringTableHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
    },
    cateringRow: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      color: "#202020",
      fontSize: 12,
      paddingTop: 8,
      paddingBottom: 6,
      borderBottom: "1px solid #d0d0d0",
    },

    cargoHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
      fontWeight: "bold",
      marginTop: 8,
      padding: 3
    },
    cargoTableHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
      fontSize: 10,
    },
    cargoRow: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      color: "#202020",
      fontSize: 12,
      borderBottom: "1px solid #d0d0d0",
    },

    cargoClientTableHeader: {
      marginLeft: 30,
      backgroundColor: "rgba(0,0,0,0.3)",
      fontSize: 10,
    },
    cargoClientRow: {
      marginLeft: 30,
      backgroundColor: "rgba(221, 221, 221, 1)",
      color: "#202020",
      fontSize: 10,
      paddingTop: 8,
      paddingBottom: 6,
      borderBottom: "1px solid #d0d0d0",
    },

    weightLine: {
      lineHeight: "20px",
      fontSize: 14,
    },
    WeightLineTotal: {
      lineHeight: "20px",
      fontSize: 14,
      backgroundColor: "rgba(0,0,0,0.4)"
    },

    noteHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
      fontSize: 14,
      fontWeight: "bold",
      padding: 3,
      color: "#ffffff"
    },
    eventHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
      fontSize: 14,
      fontWeight: "bold",
      padding: 3,
      color: "#ffff00"
    },
    noteBody: {
      lineHeight: 1, 
      fontSize:"12px", 
      color: "#000000", 
      whiteSpace: "pre-line", 
      border: "1px solid #ffffff", 
      backgroundColor: "#dddddd",
      padding: 2
    },
    eventBody: {
      lineHeight: 1, 
      fontSize:"12px", 
      color: "#000000", 
      whiteSpace: "pre-line", 
      border: "1px solid #ffffff", 
      backgroundColor: "#ffff99",
      padding: 2
    },
    diversionBody: {
      lineHeight: 1, 
      fontSize:"12px", 
      whiteSpace: "pre-line", 
      color: "#ffffff", 
      border: "1px solid #ffffff", 
      backgroundColor: "rgb(118,71,152)", 
      padding: 2
    },

    returnToStandBody: {
      lineHeight: 1, 
      fontSize:"12px", 
      whiteSpace: "pre-line", 
      color: "#ffffff", 
      border: "1px solid #ffffff", 
      backgroundColor: "#cf0000", 
      padding: 2
    },

    rampBody: {
      lineHeight: 1, 
      fontSize:"12px", 
      whiteSpace: "pre-line", 
      color: "#ffffff", 
      border: "1px solid #909090", 
      backgroundColor: "rgb(128, 91, 44)", 
      padding: 2
    },

    delayApplied: {
      color: "#ffffff", 
      border: "1px solid #ffff00", 
      backgroundColor: "#cf0000"
    },
    delayInfo: {
      lineHeight: 1, 
      fontSize:"12px", 
      color: "#000000", 
      backgroundColor: "#ffff99", 
      marginBottom: 4
    },

    checklistNote: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      color: "#202020",
      // whiteSpace: "pre",
      fontSize: 12,
      lineHeight: 1,
      // overflowX: "scroll",
    },

    checklistSectionHeader: {
      backgroundColor: "rgba(0,0,0,0.3)",
      fontSize: 18,
      fontWeight: "bold",
      padding: "8px 3px"
    },
    checklistItem: {
      lineHeight: 1, 
      fontSize: 14, 
      backgroundColor: "rgba(255, 255, 255, 1)",
      color: "#202020",
      padding: "6px 3px"
    },
    cancelled: {
      border: "1px solid #ffffff", 
      backgroundColor: "#999999",
    },
  }
}
export default TripToolTipStyles;
